import 'whatwg-fetch';
import React from 'react';
import getAvailableServices from '../../utils/getAvailableServices';
import getDistanceLabel from '../../utils/getDistanceLabel';
import {
    ENDPOINT_SEND_FEEDBACK,
} from '../../constants/apiEndpoints';

class MobilePopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formActive: false,
            email: '',
            feedback: '',
            machineIds: '',
            submitSuccessfull: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    closePopup = e => {
        e.stopPropagation();

        this.props.onClose();
    };

    handleClickOutside = e => {
        if (e.target.getAttribute('class') === 'MobilePopup') {
            this.props.onClose();
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }

    toggleForm = () => {
        this.setState({
            formActive: !this.state.formActive,
        });
    }

    handleChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        let machineIds = this.props.activeMarker.machines || [];
        machineIds = machineIds.map(x => x.machine_id);
        machineIds = machineIds.sort((a, b) => a - b);

        return fetch(ENDPOINT_SEND_FEEDBACK, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                feeback: this.state.feedback,
                machineIds: machineIds.join(),
            })
        })
            .then(response => {
                return response.json();
            })
            .then(json => {
                this.setState({submitSuccessfull: true})
            })
            .catch(error => {
                this.setState({submitSuccessfull: false})
            });
    }

    render() {
        const {
            activeMarker,
            userPos,
            labels,
            services,
            language,
        } = this.props;
        const serviceLabelType = 'popup';
        const availableServices = getAvailableServices(
            activeMarker,
            services,
            language,
            serviceLabelType
        );

        let machineIds = activeMarker.machines || [];
        machineIds = machineIds.map(x => x.machine_id);
        machineIds = machineIds.sort((a, b) => a - b);

        let openingHours = '';

        // TODO: Remove below logic when realtime api is in production
        if (activeMarker.machines && activeMarker.machines.length) {
            const machineWithOpeningHours = activeMarker.machines
                .filter(machine => machine.opening_hours !== '')
                .slice(-1)[0];

            if (machineWithOpeningHours) {
                openingHours = machineWithOpeningHours.opening_hours;
            }
        }

        if (activeMarker.opening_info) {
            openingHours = activeMarker.opening_info;
        }

        let distance = null;
        if (userPos) {
            distance = getDistanceLabel(
                { lat: userPos.lat, lng: userPos.lng },
                { lat: activeMarker.point.coordinates[1], lng: activeMarker.point.coordinates[0] }
            );
        }

        const hasNFC = Boolean(activeMarker.services.find(x => x.identifier === 'NFC'));

        return (
            <div className="MobilePopup">
                <div className="MobilePopup__Container">
                    <div className="MobilePopup__Header">
                        <div className="MobilePopup__MachineId">
                            <div>
                                {`${labels.machineId}: `}
                                {`${machineIds.join(', ')}`}
                            </div>
                            <div>
                                {hasNFC ? (<div class="InfoWindow__NFC"></div>) : ('')}
                            </div>
                        </div>
                        {`${activeMarker.address1}, ${
                            activeMarker.address2
                                ? `${activeMarker.address2}, `
                                : ''
                        }${activeMarker.city}`}
                        <button
                            className="MobilePopup__Close"
                            onClick={this.closePopup}
                        >
                            &times;
                        </button>
                    </div>
                    {!this.state.formActive && (
                        <div className="MobilePopup__InnerContainer">
                            <div className="MobilePopup__Content">
                                {availableServices.withdrawalServices && availableServices.withdrawalServices.length > 0 && (
                                    <p
                                        className="MobilePopup__Info MobilePopup__Info--Withdrawal"
                                        dangerouslySetInnerHTML={{
                                            __html: `<strong>${
                                                labels.withdrawal
                                            }:</strong> ${
                                                availableServices.withdrawalServices.join('')
                                            }`
                                        }}
                                    />
                                )}
                                {availableServices.depositServices && availableServices.depositServices.length > 0 && (
                                    <p
                                        className="MobilePopup__Info MobilePopup__Info--Deposit"
                                        dangerouslySetInnerHTML={{
                                            __html: `<strong>${labels.deposit}:</strong> ${
                                                availableServices.depositServices.join('')
                                            }`
                                        }}
                                    />
                                )}
                                {!activeMarker.is_open && (
                                    <p className="MobilePopup__Info MobilePopup__Info--Note">
                                        {labels.isClosed}
                                    </p>
                                )}

                                {distance && (
                                    <p
                                        className="MobilePopup__Info"
                                        dangerouslySetInnerHTML={{
                                            __html: `<strong>${labels.distanceToYou}:</strong> ${
                                                distance
                                            }`
                                        }}
                                    />
                                )}

                                {activeMarker.rates && activeMarker.rates.length ? (
                                    <div className="MobilePopup__RateContainer">
                                        <h5 className="MobilePopup__Label">{labels.exchangeRates}:&nbsp;</h5>
                                        <div className="MobilePopup__RateContent">
                                            {activeMarker.rates.map(rate => (
                                                <p
                                                    key={rate.currency}
                                                    className="MobilePopup__Info MobilePopup__Info--Rate"
                                                >
                                                    {rate.currency}:{' '}
                                                    {(rate.rate / rate.unit).toFixed(4)}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {activeMarker.currencies && (
                                    <div className="MobilePopup__RateContainer">
                                        <h5 className="MobilePopup__Label">
                                            {labels.currencies}:&nbsp;
                                        </h5>
                                        <div className="MobilePopup__RateContent">
                                        {activeMarker.currencies.map(value => (
                                            <p key={value} className="MobilePopup__Info MobilePopup__Info--Currency">
                                                <strong>{value.currency}:</strong> {value.denomination + ' '} 
                                            </p>  
                                        ))}
                                        </div>
                                    </div>
                                )}

                                {openingHours !== '' && (
                                    <p
                                        className="MobilePopup__Info MobilePopup__Info--Hours"
                                        dangerouslySetInnerHTML={{
                                            __html: `<strong>${labels.businessHours}:</strong> ${
                                                openingHours
                                            }`
                                        }}
                                    />
                                )}
                            </div>
                            <div className="MobilePopup__FeedbackContainer">
                                <span onClick={this.toggleForm} className="MobilePopup__FeedbackButton" role="button">{labels.feedbackButton}</span>
                            </div>
                        </div>
                    )}
                    {this.state.formActive && (
                        <div>
                            {this.state.submitSuccessfull === true &&
                                <p className="MobilePopup__FormMessage">{labels.sendSuccess}</p>
                            }
                            {this.state.submitSuccessfull === false &&
                                <p className="MobilePopup__FormMessage">{labels.sendFail}</p>
                            }
                            {this.state.submitSuccessfull === '' &&
                                <form className="MobilePopup__Form" onSubmit={this.handleSubmit}>
                                    <h2 className="MobilePopup__FormTitle">{labels.feedbackHeading}</h2>
                                    <input
                                        name="email"
                                        className="MobilePopup__FormEmail"
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        placeholder={labels.email}
                                        type="email"
                                        required={true}
                                    />
                                    <textarea
                                        name="feedback"
                                        className="MobilePopup__FormFeedback"
                                        value={this.state.feedback}
                                        onChange={this.handleChange}
                                        required={true}
                                    />
                                    <input type="hidden" value={machineIds.join()} />
                                    <input className="button" type="submit" value={labels.send} />
                                </form>
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

MobilePopup.defaultProps = {};

export default MobilePopup;